<template>
  <div class="HintView">
    <HintComponent
      :configurations="configurations"
      @action="handleAction"
    />

    <div class="actions">
      <BaseButton
        type="transparent"
        icon="icon-arrow-left"
        @click="emit('previous')"
      >
        {{ t('hiring.base.back') }}
      </BaseButton>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, type PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import BaseButton from '@/modules/core/components/ui/BaseButton.vue'
import { ForWhomEnum } from '@/modules/core/models/enums'
import { UserRoleEnum } from '@/modules/core/models/enums'
import type { FormAnswersType } from '@/modules/core/models/types'
import type Insured from '@/modules/common/common/models/APP/Insured'
import DentalConfigurations from '@/modules/dental/common/models/APP/DentalConfigurations'
import HintComponent from '@/modules/dental/rater/components/HintComponent.vue'

const { t } = useI18n()

const props = defineProps({
  nextForm: {
    type: Array,
    required: true
  },
  answers: {
    type: Object as PropType<FormAnswersType>,
    default: () => {}
  },
  configurations: {
    type: DentalConfigurations,
    default: () => {}
  },
  type: {
    type: String
  },
  extra: {
    type: Object
  }
})

defineExpose({ triggerSubmit })

const emit = defineEmits(['previous', 'next'])
const onlyFamily = ref(false)
let skipRelationshipView = false

function handleAction(value: boolean) {
  onlyFamily.value = value
  emit('next', value)
}

function updateInsuredsRelationship(hasRelationship: string) {
  const insureds: Insured[] = props.answers.insureds
  if (hasRelationship === 'no') {
    const defaultOption = props.configurations.relationships.find((elm) => elm.default)
    if (
      (props.answers.forWhom === ForWhomEnum.NOT_ME && props.answers.insureds.length === 1) ||
      (props.answers.forWhom === ForWhomEnum.ME_MORE && props.answers.insureds.length === 2)
    ) {
      const index = insureds.findIndex((elm) => elm.role === UserRoleEnum.INSURED)
      if (index > -1) {
        skipRelationshipView = true
        insureds[index].relationship = defaultOption?.id
      }
    }
  }
  return insureds
}

function nextPage(hasRelationship: string) {
  if (skipRelationshipView && props.nextForm.length === 3) {
    return props.nextForm[2]
  }
  if (hasRelationship === 'no') {
    return props.nextForm[1]
  }
  return props.nextForm[0]
}

function triggerSubmit() {
  const hasRelationship = onlyFamily.value ? 'yes' : 'no'
  const insureds = updateInsuredsRelationship(hasRelationship)
  return {
    page: nextPage(hasRelationship),
    answers: { hasRelationship, insureds }
  }
}
</script>
<style lang="scss" scoped>
.HintView {
  .actions {
    margin-top: $spacing-18;
    gap: $gap-s;
  }

  margin-bottom: $spacing-10;
}
</style>
